import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CouponModel } from '../../../models/coupon'
import { numberFormat } from '../../../utils/nunberFormat'
import { FETCH_MORE_DATA_AMOUNT } from '../../../config-global'
import moment from 'moment'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TableSearchNotFound from '../../../components/tableSearchNotFound'

interface Props {
    rows: CouponModel[]
    currentPage: any
    onOpenMenu : Function
    searchValue : string
    isSearchNotFound : boolean
}

const TableAmount = ({ rows, currentPage , onOpenMenu , searchValue ,isSearchNotFound}: Props) => {
    const { t } = useTranslation('global')

    return (
        <TableContainer sx={{ mb: 1 }}>
            <Table>
                <TableHead sx={{ background: "#F4F6F8" }}>
                    <TableRow>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.No")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Coupon name")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Coupon Code")}</TableCell>
                        {/* <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Type coupon")}</TableCell> */}
                        <TableCell sx={{ display: "block", borderBottom: 'none' }}>{t("coupon_page.Discount by Amount")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Limit Use")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Usage")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Buy Amount")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.Start date")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("coupon_page.End date")}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows?.map((row: CouponModel, index: number) => {
                        const { id, name, couponCode, discount, limitUsing, used, buyByAmount, startDate, endDate } = row;
                        return (
                            <TableRow key={index}>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {numberFormat(index + 1 + FETCH_MORE_DATA_AMOUNT * (currentPage - 1))}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {name}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {couponCode}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {numberFormat(discount)} kip
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {limitUsing}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {used}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {numberFormat(buyByAmount)} kip
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {moment(new Date(startDate)).format('DD/MM/YYYY')}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    {moment(new Date(endDate)).format('DD/MM/YYYY')}
                                </TableCell>
                                <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                    <IconButton size="large" color="inherit" onClick={(e: any) => onOpenMenu(e, id)}>
                                        <MoreHorizIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
                {isSearchNotFound && (
                    <TableSearchNotFound searchValue={searchValue} colSpan={12} />
                )}
            </Table>
        </TableContainer>
    )
}

export default TableAmount